import { ReactElement, ReactNode, useState } from 'react'

import { useScrollPosition } from '@n8tb1t/use-scroll-position'
import classNames from 'classnames'
import { useSelector } from 'react-redux'

import { selectIsSidebarCollapsed } from 'selectors/ui'
import { RootReduxState } from 'types'

import * as styles from '../styles.module.scss'

const STICKY_PADDING_Y = 10

interface Props {
    topOffset: number
    className?: string
    children: ReactNode
    hoverOverflow?: boolean
}

const StickyHeader = ({
    topOffset = 0,
    className,
    children,
    hoverOverflow = false,
}: Props): ReactElement | null => {
    const [visible, setVisible] = useState(false)
    const isSidebarCollapsed = useSelector((state: RootReduxState) =>
        selectIsSidebarCollapsed(state)
    )

    useScrollPosition(({ currPos }: { currPos: { x: number; y: number } }) => {
        setVisible(currPos.y < -topOffset + STICKY_PADDING_Y)
    })

    return (
        <div
            className={classNames(
                styles.stickyContainer,
                {
                    [styles.stickyContainer_visible]: visible,
                    [styles.stickyContainer_sidebarCollapsed]:
                        isSidebarCollapsed,
                    [styles.stickyContainer_hoverOverflow]: hoverOverflow,
                },
                className
            )}
        >
            {children}
        </div>
    )
}

export default StickyHeader
